export default "__VITE_ASSET__CoE$P4Do__"